module.exports = __webpack_public_path__ + "static/media/warning_icon.eaf891c0.svg";